<template>
	<div>
		<myheader :backFlag="false" headTitle="加入企业"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div style="margin: .5rem auto .2rem;text-align: center;">
						<img style="width: 3rem; height: 3rem; "
							:src="applyStatus===3?fail:(applyStatus===2?success:review)">
						<div class="text12 textcolor666 margin_top_2">
							{{applyStatus===3?'申请失败':(applyStatus===2?'加入成功':'请等待审核')}}</div>
						<div class="text14 textcolor333 margin_top_3 font_weight_bold">{{corpName}}</div>
						<div v-if="applyStatus!==3" class="text12 textcolor666 margin_top_5">加入已有认证企业</div>
					</div>
				</div>
				<div v-if="applyStatus!==3" class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor666">审核状态：</div>
					<div class="text14 textcolor333 font_weight_900" style="position: absolute;right:.5rem;top: 1rem;">
						{{applyStatusText}}
					</div>
					<div class="horizontal_line margin_top_2"></div>
					<div class="text12 textcolor333 margin_top_5">{{applyStatus===2?'企业管理员已审核通过，可进行下一步操作。':'等待企业管理员审核通过后，即可加入企业。'}}</div>
				</div>
				<div v-if="applyStatus===3" class="all_tips_content_card margin_top_10">
					<div class="text14 textcolor666 display_inline_block" style="width: 40%;">{{'审批人：'+auditorName}}
					</div>
					<div class="text14 textcolor666 display_inline_block all_text_right" style="width: 60%;">
						{{'审批时间：'+Tool.formate(auditTime,"yyyy-MM-dd")}}
					</div>
					<div class="horizontal_line margin_top_2"></div>
					<div class="text12 textcolor333 margin_top_5">{{'驳回原因：'+(auditMemo?auditMemo:'您不满足加入本企业的条件')}}</div>
				</div>
				<div class="all_tips_bottom_card">
					<button v-if="applyStatus===3" class="all_button22 text16 bmain_active"
						style="width: 45%;margin-right: 10%;" @click="deleteItem()">删除</button>
					<button class="all_button22 text16 bmain_active" :style="{width: applyStatus!==3?'100%':'45%'}"
						@click="jump()">关闭</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Dialog
	} from 'vant';
	export default {
		data() {
			return {
				//申请id
				applyId: '',
				//企业id
				corpId: '',
				//企业名称
				corpName: '',
				//申请加入状态文本
				applyStatusText: '',
				//申请加入状态
				applyStatus: '',
				//不通过原因
				auditMemo: '',
				//驳回时间
				auditTime: '',
				//驳回管理员
				auditorName: '',
				//返回企业列表是否刷新
				backRefresh:'',
				//成功
				success: require('@/assets/images/selected.svg'),
				//等待中
				review: require('@/assets/images/review.svg'),
				//失败
				fail: require('@/assets/images/fail.svg'),
			}
		},
		methods: {
			//删除加入企业失败申请
			deleteItem() {
				var that = this
				Dialog.confirm({
						title: '删除确认',
						message: '确定删除该条加入企业申请？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						that.$store.dispatch(that.$LoadShow, true)
						that.$post('/corp/m/api/removeJoinApply?applyId=' + this.applyId).then((res) => {
							that.$store.dispatch(that.$LoadShow, false)
							if (res.success) {
								that.$store.commit('changeEnterpriseDelete', true)
								that.$Toast("删除成功！");
								that.$router.go(-1)
							} else {
								that.$Toast(res.message || "删除失败！");
							}
						});
					})
					.catch(() => {
						// on cancel
					});
			},
			// 返回结果后进行跳转下一页
			jump() {
				if(this.backRefresh){
					this.$store.commit('changeEnterpriseRefresh', true)
				}
				if (this.applyId) {
					this.$router.go(-1)
				} else {
					this.$router.go(-2)
				}
			},
			//获取加入企业详情信息
			getStatusInfo() {
				this.$post('/corp/m/api/getJoinApply?applyId=' + this.applyId)
					.then((res) => {
						if (res.success && res.data) {
							this.applyStatus = res.data.applyStatus
							this.applyStatusText = res.data.applyStatusText
							this.auditMemo = res.data.auditMemo
							this.auditTime = res.data.auditTime
							this.auditorName = res.data.auditorName
						}
					})
			},
			//初始化
			init() {
				this.$store.commit('changeEnterpriseDelete', false)
				this.$store.commit('changeEnterpriseRefresh', false)
				this.backRefresh = this.$route.query.refresh
				this.applyId = this.$route.query.applyId
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				this.applyStatusText = this.$route.query.certifyStatusText
				this.applyStatus = this.$route.query.applyStatus
				if (this.applyId) {
					this.getStatusInfo()
				}
			}
		},
		mounted() {
			this.init()
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>